import { ButtonDefault } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { ARTICLE_REPORT_STATUS_LABELS, type ArticleReportStatusType } from '@/defs/articleReport'

type Props = {
  status: ArticleReportStatusType
  total?: number
}

export const ArticleReportStatus = ({ status, total }: Props) => {
  const { colorScheme, icon, labelPlural } = ARTICLE_REPORT_STATUS_LABELS[status]

  const hasNone = total === 0

  return (
    <ButtonDefault
      as='span'
      colorScheme={hasNone ? 'success' : colorScheme}
      hover='none'
      shadow='none'
      size={total === undefined ? 'xs' : 'sm'}
    >
      {total === undefined ? (
        <Icon name={icon} />
      ) : (
        <IconWithLabel iconBefore={hasNone ? 'check' : icon} wrapNone>
          {hasNone ? `No ${labelPlural}` : `${labelPlural}: ${total}`}
        </IconWithLabel>
      )}
    </ButtonDefault>
  )
}
